import { io, Socket } from 'socket.io-client'
import { env } from '@/lib/env'
import keycloak from '@/lib/keycloak'
import { ensureFreshKeycloakToken } from '@/lib/auth-token'

type SocketAuth = { userId?: string; token?: string }

/**
 * Handshake credentials, evaluated on every (re)connection: access tokens are short-lived and
 * the server verifies this token before accepting the patient's consent answer.
 */
export function provideSocketAuth(callback: (auth: SocketAuth) => void): void {
  ensureFreshKeycloakToken()
    .catch(() => keycloak.token)
    .then((token) => callback({ userId: keycloak.tokenParsed?.sub, token: token ?? keycloak.token }))
}

let socket: Socket | null = null

export function getSocket(): Socket {
  if (!socket) {
    const apiUrl = new URL(env.NEXT_PUBLIC_API_GATEWAY_URL)
    const baseUrl = `${apiUrl.protocol}//${apiUrl.hostname}:${apiUrl.port}`

    socket = io(baseUrl, {
      auth: provideSocketAuth,
      autoConnect: false,
    })
  }
  return socket
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}
